// postMessageToApp.js
'use strict';
import { goBack } from 'redux-first-history';

import {
  getIsOnAndroidWebview,
  getIsOnIOSWebview,
  getIsOnWebviewFlutterApp,
  getIsXUserAgent,
} from '../resource/getUserAgent.js';
import { push } from '../action/navigationAction.js';

/**
 * Post message to SWAG app.
 * @kind action
 * @param {string} {message} - passing message to mobile
 * @param {string} {[fallbackRouteInWebApp]} - when the mobile app API is unavaliable. will fallback to the route
 * @param {Array} {[messageArgs]} - array of additional arguments to pass to the webview handler
 * @return {Promise} Action promise.
 */
const postMessageToApp =
  ({ message, fallbackRouteInWebApp, messageArgs = [] }) =>
  async dispatch => {
    if (!message) return false;

    let isSentToApp = false;

    if (getIsXUserAgent() && window.WebApp?.callHandler) {
      // new method to post message to app
      window.WebApp.callHandler(message, ...messageArgs);
      isSentToApp = true;
    }

    // backward compatibility for Android
    // Same as the iOS branch below: only return when the handler is really
    // there, or the fallbacks below get skipped.
    if (getIsOnAndroidWebview() && window.WebApp?.postMessage) {
      if (message === 'actionUrl' && messageArgs?.[0]) {
        return window.WebApp.postMessage(messageArgs[0]);
      }

      return window.WebApp.postMessage(message);
    }

    // backward compatibility for iOS
    if (getIsOnIOSWebview()) {
      // webview_flutter has no messageHandlers.WebApp, so only return when the
      // handler is really there, or the fallbacks below get skipped.
      const iosWebAppHandler = window.webkit?.messageHandlers?.WebApp;
      if (iosWebAppHandler?.postMessage) {
        if (message === 'actionUrl' && messageArgs?.[0]) {
          return iosWebAppHandler.postMessage(messageArgs[0]);
        }
        return iosWebAppHandler.postMessage(message);
      }
    }

    if (isSentToApp) return;

    // webview_flutter has no web->app channel yet; doing nothing beats
    // routing the creator WebView to the SPA home.
    if (getIsOnWebviewFlutterApp()) return;

    if ('closeWebView' === message) {
      if ('home' === fallbackRouteInWebApp) {
        return dispatch(push('/'));
      } else {
        return dispatch(goBack());
      }
    }

    if (fallbackRouteInWebApp) {
      return dispatch(push(fallbackRouteInWebApp));
    }
  };

export default postMessageToApp;
